import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import {
	getHiredList,
	getCompanies
} from "../../../../Company/containers/Report/actions";
import _ from "lodash";
import ls from "Localization";

import NewSolicitationContractForm from "containers/Contracts/components/NewSolicitationContractForm";
import Stepper from "containers/Contracts/components/Stepper";

import { createSolicitationContract } from "./actions";
import { getContractList } from "../../ReportAll/actions";
import { change } from "redux-form";
import { contractSolicitationTypes } from "types/contractSolicitation";
import moment from "moment";

let findHirerList = null;
let findHiredList = null;
let findContractList = null;

const NewSolicitationContract = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	const { loading, errors } = useSelector(s => s.newSolicitationContract);

	const [hirer, setHirer] = useState("");
	const [hired, setHired] = useState("");
	const [contractReference, setContractReference] = useState("");
	const [file, setFile] = useState(null);
	const [modality, setModality] = useState("hybrid");
	const [value, setValue] = useState(0);

	const { items: companies, hireds } = useSelector(s => s.company);
	const { items: contracts } = useSelector(s => s.contracts);
	const solicitation_contract_create = useSelector(
		s => s.form.solicitation_contract_create
	);

	const onSubmit = data => {
		dispatch(
			createSolicitationContract(
				{
					hirer: data.hirer ? data.hirer.value : "",
					hired: data.hired ? data.hired.value : "",
					contractType: data.contractType ? data.contractType.value : "",
					role: data.role,
					contractReference: contractReference ?? "",
					priority: data.priority ? data.priority.value : "",
					tier: data.tier ? data.tier.value : "",
					activitiesDescription: data.activitiesDescription,
					modality,
					value: value,
					paymentDate: data.paymentDate,
					lifespan: data.lifespan,
					startDate: moment(data.startDate, "DD/MM/YYYY"),
					additionalInformation: data.additionalInformation ?? ""
				},
				file,
				(err, result) => {
					if (err) {
						if (err.code) {
							alert("1" + err.code);
						} else if (typeof err === "string") alert("2" + err);
						else if (err.errors && err.errors.default)
							alert(err.errors.default);
						else alert(JSON.stringify("3" + err));
					} else if (result && result.contractSolicitation) {
						history.push(`/contracts/contract-solicitation-completed/`, {
							contractId: result.contractSolicitation._id
						});
					}
				}
			)
		);
	};

	const handleFindHirerList = businessName => {
		if (findHirerList) {
			findHirerList.cancel();
		}

		let filterStr = "&filters[isHired]=true";

		if (businessName) filterStr += `&filters[businessName]=${businessName}`;

		findHirerList = _.debounce(
			() =>
				dispatch(
					getCompanies(0, 10, filterStr, "createdAt", true, false, err => {
						if (err)
							alert(
								"Não foi possível carregar os dados, erro: " + typeof err ===
									"string"
									? err
									: JSON.stringify(err)
							);
					})
				),
			500
		);

		findHirerList();
	};

	const handleSelectHirer = el => {
		setHirer(el.value);
		setHired("");
		setContractReference("");
		handleFindHiredList(el.value);
		handleFindContractReferenceList(el.value);
		dispatch(change("solicitation_contract_create", "hired", ""));
		dispatch(change("solicitation_contract_create", "contractReference", ""));
	};

	const handleFindHired = el => handleFindHiredList(hirer, el);

	const handleSelectHired = el => {
		if (el.value) {
			setHired(el.value);
		}
	};

	const handleSelectContractReference = el => {
		if (el.value) {
			setContractReference(el.value);
		}
	};

	const handleFindHiredList = (hirer_id, businessName = null) => {
		if (!hirer_id) {
			return;
		}

		if (findHiredList) {
			findHiredList.cancel();
		}

		let filterStr = "";

		if (businessName) filterStr += `&filters[businessName]=${businessName}`;

		findHiredList = _.debounce(
			() =>
				dispatch(
					getHiredList(hirer_id, filterStr, err => {
						if (err)
							alert(
								"Não foi possível carregar os dados, erro: " + typeof err ===
									"string"
									? err
									: "Erro: " + JSON.stringify(err)
							);
					})
				),
			500
		);

		findHiredList();
	};

	const handleFindContractReferenceList = (templateName = null) => {
		if (!templateName || !hirer || !hired) {
			return;
		}

		const filterStr = `&filters[mei]=${hirer}&filters[hired]=${hired}&filters[template.name]=${templateName}`;

		findContractList = _.debounce(
			() =>
				dispatch(
					getContractList(0, 10, filterStr, "createdAt", true, false, err => {
						if (err)
							alert(
								"Não foi possível carregar os dados, erro: " + typeof err ===
									"string"
									? err
									: "Erro: " + JSON.stringify(err)
							);
					})
				),
			500
		);

		findContractList();
	};

	const handleChangeFile = file => {
		if (file) setFile(file);
	};

	const handleChangeRadio = e => {
		if (e) setModality(e.target.value);
	};

	const typeData = Object.keys(contractSolicitationTypes).map(c => ({
		value: c,
		label: ls[contractSolicitationTypes[c]]
	}));

	return (
		<Container className="dashboard">
			<Card>
				<CardBody>
					<Stepper currentStep={2} />

					<Row>
						<Col
							md={{
								offset: 3,
								size: 6
							}}
							sm="12"
						>
							<Row>
								<Col>
									<h2 className="mb-4 text-center">Solicitação de contrato</h2>
								</Col>
							</Row>
							<NewSolicitationContractForm
								isInvalid={
									solicitation_contract_create &&
									!!solicitation_contract_create.syncErrors
								}
								loading={loading}
								errors={errors}
								file={file}
								onChangeFile={handleChangeFile}
								onChangeRadio={handleChangeRadio}
								meis={companies}
								hireds={hireds}
								contracts={contracts}
								onSearchMei={handleFindHirerList}
								onSelectMei={handleSelectHirer}
								onSearchHired={handleFindHired}
								onSelectHired={handleSelectHired}
								onSelectContractReference={handleSelectContractReference}
								onSearchContractReference={handleFindContractReferenceList}
								typeData={typeData}
								onSubmit={onSubmit}
								value={value}
								setValue={setValue}
							/>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</Container>
	);
};

export default NewSolicitationContract;
